/** @jsx React.DOM */'use strict';

var assign 	= require('object-assign');
var React 	= require('react');

var logger 	= require('../../utils/logger.js');

var Actions = require('../actions/course-search-actions.js');
var Store 	= require('../stores/course-search-store.js');

var tgApi = require('../../api/tg-api.js');

function getFacetValue(navigatedFacet) {
	return navigatedFacet !== null ? navigatedFacet.value : null;
}

function getFilterRequest(navState, selectedValues) {
	var filterRequest = {
		'baseSearchContext': navState.baseSearchContext,
		'country': getFacetValue(navState.navigatedCountry),
		'region': getFacetValue(navState.navigatedRegion),
		'county': getFacetValue(navState.navigatedCounty),
		'magazineRating': getFacetValue(navState.navigatedMagazineRating),
		'playerRating': getFacetValue(navState.navigatedPlayerRating),
		'greenFee': getFacetValue(navState.navigatedGreenFeesBand),
		'golfWorldTopHundredValue' : getFacetValue(navState.navigatedGolfWorldTopHundredValue),
		'searchContext': navState.searchContext,
		'searchTerm': navState.searchTerm,
		'sortOption' : navState.selectedSortOption,
		'longitude' : navState.longitude,
		'latitude' : navState.latitude,
		'distance' : navState.distance ? navState.distance : 10
	};

	if (selectedValues) {
		assign(filterRequest, selectedValues);
	}

	return filterRequest;
}

function loadInitialData(navState) {
	var filterRequest = getFilterRequest(navState);
	Actions.updateFilters(filterRequest);
}

var view = React.createClass({
	getInitialState: function () {
		return Store.getState();
	},

	componentWillMount: function () {
		Store.addChangeListener(this.onStoreChange);
		loadInitialData(this.props.navstate);
	},

	componentWillUnmount: function () {
		Store.removeChangeListener(this.onStoreChange);
	},

	onStoreChange: function () {
		this.setState(Store.getState());
	},

	render: function () {

		var navstate = this.props.navstate;
		var defaultLocation = this.props.defaultLocation;

		var state = this.state;

		logger.debug({
			view: 'Course Search',
			message: 'Render',
			state: state
		});

		var countryDisabled = state.isLoading || state.navigatedCountry != null || (state.countryItems.length == 0 && state.navigatedCountry == null);
		var regionDisabled = state.isLoading || state.navigatedCountry == null || state.navigatedRegion != null || (state.regionItems.length == 0 && state.navigatedRegion == null);
		var countyDisabled = state.isLoading || state.navigatedRegion == null || state.navigatedCounty != null || (state.countyItems.length == 0 && state.navigatedCounty == null);
		var magazineRatingDisabled = state.isLoading || (state.magazineRatingItems.length == 0 && state.navigatedMagazineRating == null) || state.navigatedMagazineRating != null;
		var playerRatingDisabled = state.isLoading || (state.playerRatingItems.length == 0 && state.navigatedPlayerRating == null) || state.navigatedPlayerRating != null;
		var greenFeeDisabled = state.isLoading || (state.greenFeesItems.length == 0 && state.navigatedGreenFeesBand == null) || state.navigatedGreenFeesBand != null;
		var sortDisabled = state.isLoading;
		var searchTermDisabled = state.isLoading;
		var twoForeOneValueDisabled = state.isLoading;
		var golfWorldTopHundredValueDisabled = state.isLoading;
		var distanceOptionDisabled = false;

		var countryDefaultText = countryDisabled ? 'Loading...' : 'Select a country';
		var regionDefaultText = regionDisabled ? 'Loading...' : 'Select a region';
		var countyDefaultText = countyDisabled ? 'Loading...' : 'Select a county';
		var magazineRatingDefaultText = magazineRatingDisabled ? 'Loading...' : 'Select a magazine rating';
		var	playerRatingDefaultText = playerRatingDisabled ? 'Loading...' : 'Select a player rating';
		var greenFeeDefaultText = greenFeeDisabled ? 'Loading...' : 'Filter by green fees';
		var sortDefaultText = '';
		var distanceDefaultText = distanceOptionDisabled ? 'Loading...' : 'Enter distance';
		var golfWorldTopHundredValueDefaultText = golfWorldTopHundredValueDisabled ? 'Loading...' : 'Filter by golf world top100';
		var updateButtonText = state.totalResults > 0 ? 'Update results' : 'No matching results found'; 

		var greenFeeTextValues = ["Unknown","Very low","Low","Average","High","Very high"];

		if (state.isLoading) {
			countryDefaultText = 'Loading...';
			regionDefaultText = 'Loading...';
			countyDefaultText = 'Loading...';
			magazineRatingDefaultText = 'Loading...';
			playerRatingDefaultText = 'Loading...';
			sortDefaultText = 'Loading...';
			golfWorldTopHundredValueDefaultText  = 'Loading...';
			greenFeeDefaultText = 'Loading...';
			distanceDefaultText = 'Loading...';
		} else {
			countryDefaultText = 'Select a country';
			regionDefaultText = 'Select a region';
			countyDefaultText = 'Select a county';
			magazineRatingDefaultText = 'Select a magazine rating';
			playerRatingDefaultText = 'Select a player rating';
			sortDefaultText = 'Offers Available';
			golfWorldTopHundredValueDefaultText  = 'Golf world top 100 course';
			greenFeeDefaultText = 'Filter by green fees';
			distanceDefaultText = 'Enter distance';
		}

		var navigatedCountry = state.navigatedCountry != null ? state.navigatedCountry.value : null;
		var navigatedRegion = state.navigatedRegion != null ? state.navigatedRegion.value : null;
		var navigatedCounty = state.navigatedCounty != null ? state.navigatedCounty.value : null;
		var navigatedMagazineRating = state.navigatedMagazineRating != null ? state.navigatedMagazineRating.value : null;
		var navigatedPlayerRating = state.navigatedPlayerRating != null ? state.navigatedPlayerRating.value : null;
		var navigatedGreenFeesBand = state.navigatedGreenFeesBand != null ? state.navigatedGreenFeesBand.value : null;
		var selectedSortOption = state.selectedSortOption != null ? state.selectedSortOption.value : null;
		var geolocationActive = false;

		var countryListItems, regionListItems, countyListItems, magazineRatingItems, playerRatingItems, greenFeesItems, sortOptionItems, distanceOptionItems;

		if (!state.navigatedGolfWorldTopHundredValue) {
			state.navigatedGolfWorldTopHundredValue = false;
		}

		var totalResults = state.totalResults;

		if (state.countryItems) {
			countryListItems = state.countryItems.map(function (country) {
				return <option key={country.value} value={country.value}>{country.displayText} ({country.count})</option>;
			});
		}

		if (state.navigatedCountry != null) {
			countryListItems = <option key={state.navigatedCountry.value} value={state.navigatedCountry.value}>{state.navigatedCountry.displayText}</option>;
		}

		if (state.regionItems) {
			regionListItems = state.regionItems.map(function (region) {
				return <option key={region.value} value={region.value}>{region.displayText} ({region.count})</option>;
			});
		}

		if (state.navigatedRegion != null) {
			regionListItems = <option disabled="disabled" key={state.navigatedRegion.value} value={state.navigatedRegion.value}>{state.navigatedRegion.displayText}</option>;
		}

		if (state.countyItems) {
			countyListItems = state.countyItems.map(function (county) {
				return <option key={county.value} value={county.value}>{county.displayText} ({county.count})</option>;
			});
		}

		if (state.navigatedCounty != null) {
			countyListItems = <option key={state.navigatedCounty.value} value={state.navigatedCounty.value}>{state.navigatedCounty.displayText}</option>;
		}

		if (state.magazineRatingItems) {
			magazineRatingItems = state.magazineRatingItems.map(function (magazineRatingItem) {
				return <option key={magazineRatingItem.value} value={magazineRatingItem.value}>{magazineRatingItem.displayText} ({magazineRatingItem.count})</option>;
			});
		}

		if (state.navigatedMagazineRating != null) {
			magazineRatingItems = <option key={state.navigatedMagazineRating.value} value={state.navigatedMagazineRating.value}>{state.navigatedMagazineRating.displayText}</option>;
		}

		if (state.playerRatingItems) {
			playerRatingItems = state.playerRatingItems.map(function (playerRatingItem) {
				return <option key={playerRatingItem.value} value={playerRatingItem.value}>{playerRatingItem.displayText} ({playerRatingItem.count})</option>;
			});
		}

		if (state.navigatedPlayerRating != null) {
			playerRatingItems = <option key={state.navigatedPlayerRating.value} value={state.navigatedPlayerRating.value}>{state.navigatedPlayerRating.displayText}</option>;
		}

		if (state.greenFeesItems) {
			greenFeesItems = state.greenFeesItems.map(function (greenFeesBandItem) {
				return <option key={greenFeesBandItem.value} value={greenFeesBandItem.value}>{greenFeeTextValues[greenFeesBandItem.value]} ({greenFeesBandItem.count})</option>;
			});
		}

		if (state.navigatedGreenFeesBand != null) {
			greenFeesItems = <option key={state.navigatedGreenFeesBand.value} value={state.navigatedGreenFeesBand.value}>{greenFeeTextValues[state.navigatedGreenFeesBand.value]}</option>;
		}

		if (state.latitude !== null) {
			geolocationActive = true;
		}

		sortOptionItems = state.sortOptions.map(function (option) {
		
			var key = Object.keys(option)[0];
			var value = option[key];
			if (key === 'Distance (nearest first)') {
				if (!state.locationValid) {
					return
				}
			}
            if (state.selectedSortOption && (value === state.selectedSortOption)) {
				return <option selected="selected" key={key} value={value}>{key}</option>;
			} else {
				return <option key={key} value={value}>{key}</option>;
			}
		});

		distanceOptionItems = state.distanceOptions.map(function (option) {
			var key = Object.keys(option)[0];
			var value = parseInt(option[key],10);
            if (navstate.distance && (value === navstate.distance)) {
				return <option selected="selected" key={key} value={value}>{key}</option>;
			} else {
				return <option key={key} value={value}>{key}</option>;
			}
		});

		return (
			<div>
				<form className="search-filters panel course-search search-filters course-search__form  form" onSubmit={this.submitForm}>
					<div className="row">
						<div className="column large-6 font-small show-for-large-up">
							<p><strong>{navstate.heading}</strong></p>
						</div>
						<div className="column large-6 text-right font-small">
							<p className="search-filters__count">
								{state.totalResults === 1 ? <span><strong className="search-filters__count__value">{totalResults}</strong> matching review found</span> : <span><strong className="search-filters__count__value">{totalResults}</strong> matching reviews found</span>}				
							</p>
						</div>
					</div>
					<div className="row">
						<div className="column large-4">
							<select disabled={countryDisabled} value={navigatedCountry} className="form__list" onChange={this.selectCountry}>
								<option value="">{countryDefaultText}</option>
								{countryListItems}
							</select>		
							{state.navigatedCountry == null ? null : <span className="course-search__clear-filter course-search__clear-filter--select" onClick={this.clearCountry}>X</span>}				
					</div>
						<div className="column large-4">
							<select disabled={regionDisabled} value={navigatedRegion} className="form__list" onChange={this.selectRegion}>
								<option value="">{regionDefaultText}</option>
								{regionListItems}
							</select>
							{state.navigatedRegion == null ? null : <span className="course-search__clear-filter course-search__clear-filter--select" onClick={this.clearRegion}>X</span>}				
						</div>
						<div className="column large-4">
							<select disabled={countyDisabled} value={navigatedCounty} className="form__list" onChange={this.selectCounty}>
								<option value="">{countyDefaultText}</option>
								{countyListItems}
							</select>		
							{state.navigatedCounty == null ? null : <span className="course-search__clear-filter course-search__clear-filter--select" onClick={this.clearCounty}>X</span>}				
						</div>
						<div className="column large-4">
							<select disabled={magazineRatingDisabled} value={navigatedMagazineRating} className="form__list" onChange={this.selectMagazineRating}>
								<option>{magazineRatingDefaultText}</option>
								{magazineRatingItems}
							</select>
							{state.navigatedMagazineRating == null ? null : <span className="course-search__clear-filter course-search__clear-filter--select" onClick={this.clearMagazineRating}>X</span>}				
						</div>
						{/* TODO: Temporarily removed it TG-1103, Re-instate in UL-241
							<div className="column large-4">
							<select disabled={playerRatingDisabled} value={navigatedPlayerRating} className="form__list" onChange={this.selectPlayerRating}>
								<option>{playerRatingDefaultText}</option>
								{playerRatingItems}
							</select>
							{state.navigatedPlayerRating == null ? null : <span className="course-search__clear-filter course-search__clear-filter--select" onClick={this.clearPlayerRating}>X</span>}				
						</div>*/}

						<div className="column large-4">
							<select disabled={greenFeeDisabled} value={navigatedGreenFeesBand} className="form__list" onChange={this.selectGreenFee}>
								<option>{greenFeeDefaultText}</option>
								{greenFeesItems}
							</select>
							{state.navigatedGreenFeesBand == null ? null : <span className="course-search__clear-filter course-search__clear-filter--select" onClick={this.clearGreenFee}>Remove</span>}				
						</div>

						<div className="column large-4">
							<input className="searchTermInput" disabled={searchTermDisabled} type="text" value={state.isLoading ? 'Loading...' : state.searchTerm} placeholder="Enter a keyword" onBlur={this.updateSearchTerm} onMouseLeave={this.updateSearchTerm} onKeyPress={this.updateSearchTermKeyPress} />
							{state.searchTerm == null ? null : <span className="course-search__clear-filter" onClick={this.clearSearchTerm}>X</span>}				
						</div>

						<div className="column large-4">
							{state.navigatedGolfWorldTopHundredValue.value ? <input id="golfWorldTopHundredValue" disabled={golfWorldTopHundredValueDisabled} type="checkbox" checked="checked" onChange={this.toggleGolfWorldTopHundred}/> : <input id="golfWorldTopHundredValue" type="checkbox" disabled={golfWorldTopHundredValueDisabled} checked="" onChange={this.toggleGolfWorldTopHundred} />}				
							<label for="golfWorldTopHundredValue"><span>Golf World top 100 course</span></label>
						</div>

					</div>
					<a href="#" className="search-filters__clear-filters course-search__clear-filters font-small" onClick={this.clearFilters}>
						<span className="icon fi-loop"></span>
						<span>Clear all filters</span>
					</a>
					<button type="submit" disabled={!totalResults || state.isLoading} className="update search-filters__update-results button radius" onClick={this.submitForm}>
						{updateButtonText}
					</button>
				</form>
				<div className="row">
					<div className="column large-7 xxlarge-8"></div>
					<div className="course-search__sort-options column large-5 xxlarge-4">
						<div className="row">
							<div className="column small-4 large-3">
								<label className="inline">Sort by:</label>
							</div>
							<div className="column small-8 large-9">
								<select disabled={sortDisabled} id="sortBy" onChange={this.selectSortOption}>
									<option value="">{sortDefaultText}</option>
									{sortOptionItems}
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	},

	selectCountry: function (e) {
		var country = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'country': country,
			'region': '',
			'county': ''
		});
		Actions.updateFilters(filterRequest);
	},

	selectRegion: function (e) {
		var region = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'region': region,
			'county': ''
		});
		Actions.updateFilters(filterRequest);
	},

	selectCounty: function (e) {
		var county = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'county': county
		});
		Actions.updateFilters(filterRequest);
	},

	selectMagazineRating: function (e) {
		var magazineRating = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'magazineRating': magazineRating
		});
		Actions.updateFilters(filterRequest);
	},

	selectPlayerRating: function (e) {
		var playerRating = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'playerRating': playerRating
		});
		Actions.updateFilters(filterRequest);
	},

	selectGreenFee: function (e) {
		var greenFees = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'greenFees': greenFees
		});
		Actions.updateFilters(filterRequest);
	},

	selectSortOption: function (e) {
		var sortOption = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'sortOption': sortOption
		});
		$('.course-search').find('input, select, button').attr('disabled','disabled');
		$('.course-results').fadeOut(1000);

		tgApi.getCourseData(function(data) {
			window.location = data.searchResultsUrl;
		},function() {
			console.log('API call failed for some reason');
		},
		null,
		filterRequest)
	},

	selectDistanceOption: function (e) {
		var distanceOption = e.target.value;
		var filterRequest = getFilterRequest(this.state, {
			'distance': distanceOption
		});
		Actions.updateFilters(filterRequest);
	},

	toggleGolfWorldTopHundred: function (e) {
		var golfWorldTopHundredValue = e.target.checked;
		var filterRequest = getFilterRequest(this.state, {
			'golfWorldTopHundredValue': golfWorldTopHundredValue
		});
		Actions.updateFilters(filterRequest);
	},

	updateSearchTerm: function (e) {
		if (!this.state.isLoading) {
			var searchTerm = $(e.target).val();
			if (searchTerm !== '' && searchTerm !== this.state.searchTerm) {
				var filterRequest = getFilterRequest(this.state, {
					'searchTerm': searchTerm
				});
				Actions.updateFilters(filterRequest);
			}
		}
	},

	updateSearchTermKeyPress: function (e) {
		if (!this.state.isLoading && e.key === 'Enter') {
			var searchTerm = $(e.target).val();
			if (searchTerm !== '' && searchTerm !== this.state.searchTerm) {
				var filterRequest = getFilterRequest(this.state, {
					'searchTerm': searchTerm
				});
				Actions.updateFilters(filterRequest);
			}
		}
	},
	
	getLocationByGeolocation: function (e) {
		e.preventDefault();
		if (!this.state.isLoading) {

			var $input = $(e.target);
			var position = '';

			if (navigator.geolocation){
				(function(state)
				{
					navigator.geolocation.getCurrentPosition
					(
						function success(position) {
							position = [position.coords.latitude,position.coords.longitude];
							console.log(position);

							var filterRequest = getFilterRequest(state, {
								'latitude': position[0],
								'longitude': position[1],
								'sortOption': 'distance-nearest-first'
							});
							Actions.updateFilters(filterRequest);
						},
						function error() {
							alert('Geolocation failed, please try searching by location');
						}
					);
				}(this.state))
			}
		}
	},

	submitForm: function (e) {
		e.preventDefault();
		if (!this.state.isLoading) {
			Actions.submitForm(this.state.searchResultsUrl);
		}
	},

	clearFilters: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'country': '',
			'region': '',
			'county': '',
			'magazineRating': '',
			'playerRating': '',
			'greenFee': '',
			'golWorldTopHundredValue' : '',
			'searchTerm': ''
		});
		Actions.updateFilters(filterRequest);
	},

	clearCountry: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'country': '',
			'region': '',
			'county': ''
		});
		Actions.updateFilters(filterRequest);
	},

	clearRegion: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'region': '',
			'county': ''
		});
		Actions.updateFilters(filterRequest);
	},

	clearCounty: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'county': ''
		});
		Actions.updateFilters(filterRequest);
	},

	clearMagazineRating: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'magazineRating': null
		});
		Actions.updateFilters(filterRequest);
	},

	clearPlayerRating: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'playerRating': null
		});
		Actions.updateFilters(filterRequest);
	},

	clearGreenFee: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'greenFee': null
		});
		Actions.updateFilters(filterRequest);
	},

	clearSearchTerm: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'searchTerm': ''
		});
		Actions.updateFilters(filterRequest);
	},

	clearLocation: function (e) {
		e.preventDefault();
		var filterRequest = getFilterRequest(this.state, {
			'latitude': '',
			'longitude': ''
		});
		Actions.updateFilters(filterRequest);
	},

});

module.exports = view;